import { FrameRange } from "@/types/defs/pitchCorrection/segmentRender";

// Diffs the current wire-format contour against the last successfully rendered one and returns the bounding range of changed frames. Returns null when nothing changed. When there is no comparable baseline (no previous snapshot, or the length changed) the whole contour is reported as changed so the caller falls back to a full render.
export const findChangedFrameRange = ({
  currentFrequencies,
  previousFrequencies,
}: {
  currentFrequencies: number[];
  previousFrequencies: number[] | null;
}): FrameRange | null => {
  if (
    previousFrequencies === null ||
    previousFrequencies.length !== currentFrequencies.length
  ) {
    return { startIndex: 0, endIndex: currentFrequencies.length };
  }

  let firstChangedIndex = -1;
  let lastChangedIndex = -1;
  for (let index = 0; index < currentFrequencies.length; index++) {
    if (currentFrequencies[index] !== previousFrequencies[index]) {
      if (firstChangedIndex === -1) {
        firstChangedIndex = index;
      }
      lastChangedIndex = index;
    }
  }

  if (firstChangedIndex === -1) {
    return null;
  }

  return { startIndex: firstChangedIndex, endIndex: lastChangedIndex + 1 };
};
